export enum HELP_URLS {
	HOME = '/help',
	CONTACT = `${HOME}/contact`,
	RETURNS = `${HOME}/returns`,
	DROPPOINT_RETURN = `${RETURNS}/return-drop-point`,
	BY_POST_RETURN = `${RETURNS}/return-by-post`,
	ONLINE_RETURNS = `${RETURNS}/online-returns`,
	HOME_PICKUP_RETURN = `${RETURNS}/return-home-pickup`,
	ATC_FORM = `${HOME}/contact/atc-form`,
}
